import React from "react";
import { Link } from "react-router-dom";
import { renderStarRating } from "../../../utils/functions";
import { acortarTexto } from "../../../utils/functions";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import './bookItem.css';
import BookImage from "../../bookImage";
import defaultBook  from '../../../assets/defaultBook.png';



function BookItem({bookData, loading, tipo}) { 
  
  const loader = () => {
    return(
    <div className={tipo === 'relacionados' ? "bookItem-container-relacionados" :"bookItem-container"}>
        {/* Aquí puedes mostrar la información del libro en cada slide */}
        <div><Skeleton containerClassName={tipo === 'relacionados' ? "bookItem-bookimage-relacionados" : "bookItem-bookimage"} duration={0.8}/></div>
        <div className={tipo === 'relacionados' ? "bookItem-letras-relacionados":"bookItem-letras"}>
            <span className="bookItem-linea1Loading"><Skeleton duration={0.8}/></span>
            <span className="bookItem-linea2Loading"><Skeleton duration={0.8}/></span>
            {
              tipo !== 'relacionados' &&
              <div className="bookItem-estrellasLoading" >
                <Skeleton containerClassName="bookItem-estrellasLoading" duration={0.8}/>
              </div>
            }
        
        </div>
    </div>
    )
  }

  if(loading){
    return(loader());
  }else{
    return (
      <div className={tipo === 'relacionados' ? "bookItem-container-relacionados" :"bookItem-container"}>
          <Link to={`/menuestudiante/libros/${bookData.idLibro}`} className="libroItem-link">
          {/* Aquí puedes mostrar la información del libro en cada slide */}
          <BookImage
                src={bookData.imagen}
                alt={bookData.titulo}
                className={tipo === 'relacionados' ? "bookItem-bookimage-relacionados" : "bookItem-bookimage"}
          />
          <div className={tipo === 'relacionados' ? "bookItem-letras-relacionados":"bookItem-letras"}>
              <span>{acortarTexto(bookData.titulo, tipo === 'relacionados' ? 29 : 32)}</span>
              <span>{acortarTexto(bookData.nombreAutor,20)}</span>
              {
                tipo !== 'relacionados' && 
                <div className="estrellas">
                {
                  renderStarRating(bookData.calificacionPromedio, 24)
                }
                </div>
              }
          </div>
          </Link>
      </div>
    )
}

}

export default BookItem
